// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.school-payment-method{width:500px}.school-payment-method .payments-panel{margin:0}`, "",{"version":3,"sources":["webpack://./src/modals/SchoolPaymentMethod/style.scss"],"names":[],"mappings":"AACA,uBACE,WAAA,CAEA,uCACE,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
